"use client"
import { getErrorBoundary } from 'bugsnag'

export const ErrorBoundary = getErrorBoundary('f04b3ef957e2addec36cb0ed049c2440',process.env.NEXT_PUBLIC_ENV || '')